document.addEventListener('DOMContentLoaded', function() {
    const cursor = document.createElement('div');
    cursor.classList.add('cursor-dot');
    document.body.appendChild(cursor);

    let mouseX = 0, mouseY = 0;

    const savedCursorX = parseFloat(localStorage.getItem('cursorX'));
    const savedCursorY = parseFloat(localStorage.getItem('cursorY'));

    if (!isNaN(savedCursorX) && !isNaN(savedCursorY)) {
        mouseX = savedCursorX;
        mouseY = savedCursorY;
    }

    document.addEventListener('mousemove', (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
        
        
        localStorage.setItem('cursorX', mouseX);
        localStorage.setItem('cursorY', mouseY);
    });

    function checkHoverElement() {
        const element = document.elementFromPoint(mouseX, mouseY);
        if (element && (element.tagName === 'A' || element.tagName === 'BUTTON' || 
            element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || 
            element.tagName === 'SELECT')) {
            cursor.style.opacity = '0.3'; 
        } else {
            cursor.style.opacity = '1'; 
        }
    }

    function updateCursor() {
        cursor.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
        checkHoverElement(); 
        requestAnimationFrame(updateCursor);
    }

 
    cursor.style.transform = `translate(${mouseX}px, ${mouseY}px)`;
    requestAnimationFrame(updateCursor);
});